<template>
<section class="block__listAgents">
    <b-list-group >
      <b-list-group-item v-for="(list,index) in lists" :key="index" :class="putTheRightClass(list.target)">
          <b-button class="bt-list" :to="parent + '/' + list.link">
            <div class="left">
            <PuSkeleton circle :loading="isLoading" :count="1" width='20px' height="20px">
              <div class="icon" :class="putTheRightClass(list.icon)">
                {{list.icon}}
              </div>
            </PuSkeleton>
              <div class="list-number">
                <PuSkeleton :loading="isLoading" :count="1" width='20px' height="20px">
                  {{index + 1 }}
                </PuSkeleton>
              </div>
              <div class="fullname">
                <PuSkeleton :loading="isLoading" :count="1" width='120px'>
                  {{list.fullname}}
                </PuSkeleton>
              </div>
            </div>

            <div class="right">
              <div class="number">
                <PuSkeleton :loading="isLoading" :count="1" width='40px'>
                  {{list.result}}
                </PuSkeleton>
              </div> 
              <div class="target" :class="putTheRightClass(list.target)">
                <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                  {{list.target}}
                </PuSkeleton>
              </div>
              <div class="chevron">
                  <i class="far fa-chevron-right"></i>
              </div>              
            </div>
          </b-button>
      </b-list-group-item>
    </b-list-group>
    </section>
</template>


<script>
import Utils from "../../Utils"
import { mapGetters } from 'vuex'
//
export default {
  name: "ListAgents",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getGeneral'
      ])
    },  
  props:{
    lists:{
      type:Array
    },    
    parent:{
      type:String,
      default:'Parent',
    },  
  },
  data(){
    return { 
      content:"",
      isPositif:false,
      isLoading:true,
    }
  },   
  methods : {
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
  },  
  mounted (){
  },
  created(){
    console.log(this.lists);

    this.content = this.getGeneral;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>